export const SITESETUP_GET_CHARGE_BY_STATUS = 'SITESETUP_GET_CHARGE_BY_STATUS';
export const SITESETUP_CHARGE_BY_STATUS_LOADING =
  'SITESETUP_CHARGE_BY_STATUS_LOADING';
export const SITESETUP_CLEAR_CHARGE_BY_STATUS =
  'SITESETUP_CLEAR_CHARGE_BY_STATUS';
export const SITESETUP_SET_NO_RESTRICTION_CHARGE_BY_STATUS =
  'SITESETUP_SET_NO_RESTRICTION_CHARGE_BY_STATUS';
export const SITESETUP_SET_RESTRICTIONS_CHARGE_BY_STATUS =
  'SITESETUP_SET_RESTRICTIONS_CHARGE_BY_STATUS';
export const SITESETUP_EDIT_GRID_LINE_CHARGE_BY_STATUS =
  'SITESETUP_EDIT_GRID_LINE_CHARGE_BY_STATUS';



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/chargeLimit/types.js